import React, {useContext, useEffect} from 'react';
import {FormattedMessage, injectIntl} from "react-intl";

import {useFormikContext} from "formik";

import FormControlLabel from "components/radioGroup/FormControlLabel";
import RadioGroup from "components/radioGroup/RadioGroup";
import SelectTitle from "components/radioGroup/SelectTitle";

import {ListContext} from "components/List/context/ListContext";

import {ShippingMethodsDiscr} from "utils/ShippingMethods";

function MethodTypeField(props) {
    const {values, setFieldValue} = useFormikContext();
    const {selectedItem} = useContext(ListContext);

    return (
        <>
            <SelectTitle
                titleTranslationKey={'shippingMethods.form.field.discr.label'}
                required={true}
            />
            <RadioGroup
                alignListWithButton
                placeholder={props.intl.formatMessage({id: 'shippingMethods.form.field.discr.placeholder'})}
                selectedValueLabel={values.discr ? props.intl.formatMessage({id: `shippingMethods.discr.${values.discr}`}) : ''}
                name={'discr'}
                disabled={selectedItem !== null}
                value={values.discr}
                onClickAway={() => setFieldTouched('discr')}
                onChange={(event) => {
                    setFieldValue('discr', event.currentTarget.value)
                }}
            >
                {ShippingMethodsDiscr.toArray().map((discr, index) => (
                    <FormControlLabel
                        key={index}
                        value={discr}
                        label={<FormattedMessage id={`shippingMethods.discr.${discr}`} />}
                    />
                ))}
            </RadioGroup>
        </>
    );
}

export default injectIntl(MethodTypeField);
